import React from 'react';
import { useTheme } from "./ThemeContext";
import { Colors } from './utils';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <div className="TwinBuilder-toggleButton">
      <img src={theme===Colors.dark?"/switch-theme.svg":"/switch-theme-light-theme.svg"}></img>
      <label style={{ marginRight: "10px",color:theme===Colors.dark?"#FFFFFF":"#262E40" }}>Dark/Light Mode</label>
      <label className="TwinBuilder-switch">
        <input type="checkbox" onChange={toggleTheme} checked={theme === Colors.light}/>
        <span className="TwinBuilder-map-slider round">
          <span className="TwinBuilder-globe-label"></span>
          <span className="TwinBuilder-map-label"></span>
        </span>
      </label>
    </div>
  );
};

export default ThemeToggle;
